import moment from "moment";
export function isSoundPackagePending(pack) {
    return pack.approved === undefined ? false : !pack.approved || (pack.created_at ? moment(pack.created_at).isAfter(moment()) : false);
}
export function isMidiFile(fileType) {
    return fileType && fileType.startsWith('mid');
}
//# sourceMappingURL=index.js.map